// Smart Folders 상수 정의 — 사이드바 S3 섹션 (U38)
// 5개 동적 폴더: 최근·만료 임박·즐겨찾기·미분류·휴지통
// 각 폴더는 URL 쿼리 파라미터로 Explorer 필터링과 연동된다.

import { AlarmClock, Clock, Inbox, Star, Trash2, type LucideIcon } from 'lucide-react';

/** Smart Folder ID 유니온 타입 */
export type SmartFolderId = 'recent' | 'expiring' | 'pinned' | 'unfiled' | 'trash';

/** Smart Folder 정의 인터페이스 */
export interface SmartFolderDef {
  /** 폴더 고유 ID */
  id: SmartFolderId;
  /** 표시 이름 (한국어) */
  label: string;
  /** hover 시 툴팁 설명 */
  tooltip: string;
  /** lucide-react 아이콘 컴포넌트 */
  icon: LucideIcon;
  /** URL ?파라미터 — Explorer 필터링에 사용 */
  queryParam: string;
  /** queryParam의 값 */
  queryValue: string;
}

/**
 * 5개 Smart Folder 상수 배열.
 * 사이드바에서 이 순서대로 렌더된다.
 */
export const SMART_FOLDERS: SmartFolderDef[] = [
  {
    id: 'recent',
    label: '최근 (7일)',
    tooltip: '최근 7일 내에 생성하거나 수정한 항목',
    icon: Clock,
    queryParam: 'recent',
    queryValue: '7d',
  },
  {
    id: 'expiring',
    label: '만료 임박 (D-30)',
    tooltip: '만료일이 30일 이내로 남은 항목',
    icon: AlarmClock,
    queryParam: 'expires',
    queryValue: '<30d',
  },
  {
    id: 'pinned',
    label: '즐겨찾기',
    tooltip: '별 아이콘으로 고정해 둔 항목 모음',
    icon: Star,
    queryParam: 'pinned',
    queryValue: 'true',
  },
  {
    id: 'unfiled',
    label: '미분류',
    tooltip: '어떤 그룹에도 속하지 않은 항목',
    icon: Inbox,
    queryParam: 'group',
    queryValue: 'null',
  },
  {
    id: 'trash',
    label: '휴지통',
    tooltip: '삭제된 항목 — 복원하거나 영구 삭제',
    icon: Trash2,
    queryParam: 'trash',
    queryValue: '1',
  },
];

/**
 * URL searchParams에서 현재 활성 Smart Folder ID를 도출한다.
 * 매칭되는 폴더가 없으면 null 반환.
 */
export function getActiveSmartFolder(searchParams: URLSearchParams): SmartFolderId | null {
  for (const folder of SMART_FOLDERS) {
    if (searchParams.get(folder.queryParam) === folder.queryValue) {
      return folder.id;
    }
  }
  return null;
}
